// extracted by css-extract-rspack-plugin
export default {"delaySkeletonLoad":"issue-timeline-loading-module__delaySkeletonLoad__jSGd5","showAfterDelay":"issue-timeline-loading-module__showAfterDelay__Fr0JB"};